<span class="recipient-badge-avatar">
  <span class="recipient-badge-avatar-img"
        [style]="'padding: '">
    <app-image-with-loader [image]="user.avatar$ | async"
                           loaderDiameter="15"
                           [width]="34"
                           [height]="34"
                           radius="50%"></app-image-with-loader>
  </span>
</span>
<span class="recipient-badge-name text-ellipsis">
  {{ user.fullname$ | async }}
</span>
